import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { APP_ID, APP_VERSION } from '@core/tokens/tokens';
import { forkJoin, Observable, switchMap } from 'rxjs';

export const authInterceptor = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);
  const appId = inject(APP_ID);
  const appVersion = inject(APP_VERSION);
  const requestTime = new Date().getTime().toString();

  const ignoredUrlPatterns = ['cdn-cgi/trace'];

  if (ignoredUrlPatterns.some((pattern) => request.url.includes(pattern))) {
    return next(request);
  }

  return forkJoin([authService.getToken(), authService.getDeviceId()]).pipe(
    switchMap(([token, deviceId]) => {
      let formObj: Record<string, unknown> | null = null;

      if (request.body instanceof FormData) {
        const acc: Record<string, unknown> = {};
        formObj = acc;

        const formData = request.body as FormData;
        formData.forEach((value, key) => {
          if (acc[key]) {
            if (Array.isArray(acc[key])) {
              (acc[key] as unknown[]).push(value);
            } else {
              acc[key] = [acc[key], value];
            }
          } else {
            acc[key] = value;
          }
        });
      }

      const rawData =
        (typeof formObj?.data === 'string' && formObj.data) ||
        (request?.body !== undefined && request?.body !== null
          ? JSON.stringify(request.body)
          : '') ||
        '';

      const hash = authService.getAuthHash(
        rawData || '',
        requestTime,
        token || '',
        deviceId,
        appId,
        appVersion
      );

      request = request.clone({
        headers: request.headers
          .set('X-PG-App-ID', appId)
          .set('X-Pg-App-Version', appVersion)
          .set('X-Pg-Request-Time', requestTime)
          .set('X-Pg-Device-Id', deviceId)
          .set('X-Pg-Request-Hash', hash),
      });

      if (token) {
        request = request.clone({
          headers: request.headers.set('X-Pg-Token', token),
        });

        authService.extendSession();
      }

      request = request.clone({ withCredentials: true });

      return next(request);
    })
  );
};
